import { Component, Input, OnInit, ViewEncapsulation, Optional } from '@angular/core';
import { WindowRef } from '@progress/kendo-angular-dialog';
import { Subject } from 'rxjs';

import { LogService } from 'src/app/log.service';
import { ProgressMessageBarInfo, ProgressMessageType } from './progress-message.model';
import { ProgressMessageDetail, ProgressMessageDetails, ProgressDetailTypeIcons, ProgressDetailState } from './progress-message-detail.model';

@Component({
  selector: 'file360-header-bar-message-progress',
  templateUrl: './header-bar-message-progress.component.html',
  styleUrls: ['./header-bar-message-progress.component.scss',
    '../../kendo-overrides.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderBarMessageProgressComponent implements OnInit {

  ProgressDetailTypeIcons = ProgressDetailTypeIcons;
  ProgressDetailState = ProgressDetailState;
  ProgressMessageType = ProgressMessageType;

  /**
   * Header bar information 
   */
  @Input() hbi: ProgressMessageBarInfo = new ProgressMessageBarInfo("", ProgressMessageType.Progress);
  /**
   * Header bar detail information
   */
  @Input() details: ProgressMessageDetails = new ProgressMessageDetails(this.logService, new Subject<string>());

  constructor(@Optional() private windowRef: WindowRef, private logService: LogService) {
  }

  ngOnInit() {
  }

  /**
 * Stop a waiting item
 */
  stop(detail: ProgressMessageDetail) {
    this.logService.logMessage(`HeaderBarMessageProgressComponent:stop ${detail.uniqueId} enter.`);
    detail.stop();
    this.details.stopRequested = true;
  }

  /**
   * Stop all currently waiting items
   */
  stopAll() {
    this.logService.logMessage('HeaderBarMessageProgressComponent:stopAll enter.');
    this.details.stopAll();
  }

  /**
   * Show/Hide detail items
   */
  onCaret() {
    if (this.hbi.showCaretUp) {
      this.hbi.showCaretDown = true;
      this.hbi.showCaretUp = false;

    } else {
      this.hbi.showCaretDown = false;
      this.hbi.showCaretUp = true;
    }
  }

  get isExpanded() {
    return this.hbi.showCaretUp || this.hbi.isExpanded;
  }

  /**
   * Close the header bar message
   */
  onClose() {
    let msg: string = "HeaderBarMessageProgressComponent : onClose - " + this.hbi.message;
    this.logService.logMessage(msg);
    this.windowRef.close();
  }

  /**
 * Get the ngClass-formatted structure that applies the CSS style name
 * for the message type of this message. 
 */
  get messageClass() {
    return {
      "ot-message-warning": this.hbi.messageType == ProgressMessageType.Warning,
      "ot-message-confirmation": this.hbi.messageType == ProgressMessageType.Done,
      "ot-message-status": this.hbi.messageType == ProgressMessageType.Progress,
      "ot-collapsed": !this.isExpanded
    }
  }

  showStop() {
    return this.details.details.findIndex(d => d.state == ProgressDetailState.Waiting || d.state == ProgressDetailState.InProgress) >= 0;
  }
}
